import Service from "core/service";
export class TimeSheetApproveService extends Service {
  async fetchTimeSheetsWithParams(params: any) {
    try {
      return this.get("/TimesheetExpands/GetExpands", params);
    } catch (error) {
      throw error;
    }
  }

  updateTimeSheet(dataUpdate: any) {
    return this.patch(`/Timesheet(${dataUpdate.Id})`, dataUpdate);
  }

  fetchUserApprove(filter?: string) {
    let params: any = {};
    if (filter) {
      params["$filter"] = filter;
    }
    return this.get("/User", params);
  }

  updateApprovalGroup(TimesheetHeaderId: number, approvalGroupId: number) {
    return this.patch(`/Timesheet/${TimesheetHeaderId}/approval-groups/${approvalGroupId}`);
  }
}
